import styled from 'styled-components';
import Tabs from 'antd/es/tabs';

import { Header4 } from 'components/layout/headers';
import { EXTRA_LARGE_VIEWPORT, MOBILE_VIEWPORT } from 'modules/theme/config';

import type { TabsProps } from 'antd/es/tabs';

export const WeatherTab = styled(Tabs)<TabsProps>`
  .ant-tabs-tab {
    border-radius: 12px;
    padding: 0;

    &.ant-tabs-tab-active {
      background-color: #f0f4fb;
    }
  }

  .ant-tabs-tab-btn {
    border-radius: 12px;
    padding: 12px 20px;
    text-align: center;
    min-width: 120px;
  }

  &.ant-tabs-top > .ant-tabs-nav::before {
    border: 0;
  }

  &.ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar {
    height: 0;
  }

  > .ant-tabs-nav .ant-tabs-nav-operations,
  > div > .ant-tabs-nav .ant-tabs-nav-operations {
    display: none;
  }

  .ant-tabs-extra-content {
    padding: 0 4px;
    position: relative;
    transform: translateX(0);
    background-color: ${({ theme }) => theme.colors.white};

    .ant-picker {
      position: absolute;
      bottom: 0;
      right: 0;
      margin: 0;
      padding: 0;
      border: 0;
      width: 236px;

      * {
        height: 0;
        margin: 0;
        padding: 0;
      }
    }
  }

  .ant-tabs-tab + .ant-tabs-tab {
    margin-left: 24px;
  }

  @media (max-width: ${EXTRA_LARGE_VIEWPORT}px) {
    .ant-tabs-tab-btn {
      min-width: 100px;
      padding: 8px;
    }
  }

  @media (max-width: ${MOBILE_VIEWPORT}px) {
    .ant-tabs-tab + .ant-tabs-tab {
      margin-left: 0px;
    }
    .ant-tabs-extra-content {
      padding: 0 4px;
    }
    .calendar-arrow-button {
      display: none;
    }
  }

  .calendar-arrow-button {
    height: 64px;
    padding: 0 8px;
    svg {
      fill: ${({ theme }) => theme.colors.primary};
      font-size: 18px;
    }
    &[disabled] {
      cursor: default;
      background: transparent !important;
      svg {
        fill: ${({ theme }) => theme.colors.grey};
      }
    }
  }
`;

export const TabPane = styled(WeatherTab.TabPane)``;

export const WeatherIcon = styled.div<{ $url: string }>`
  background-image: url(${({ $url }) => $url});
  background-size: 120%;
  height: 36px;
  width: 36px;
  background-position: -2px -8px;

  @media (max-width: ${EXTRA_LARGE_VIEWPORT}px) {
    height: 24px;
    width: 24px;
    background-position: -2px -6px;
  }
`;

export const WeatherDetails = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin: 0 4px 0 16px;
    align-self: center;
    position: relative;
    top: -4px;
  }

  img {
    height: 24px;
    width: 24px;
  }

  @media (max-width: ${EXTRA_LARGE_VIEWPORT}px) {
    svg {
      width: 16px;
      height: 16px;
      margin: 0 4px;
    }
  }

  @media (max-width: ${MOBILE_VIEWPORT}px) {
    svg {
      width: 12px;
      height: 12px;
    }
  }
`;

export const CalendarLeftExtraContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const WeekSelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  svg {
    cursor: pointer;
    height: auto;
    width: 48px;
  }
  > span {
    cursor: pointer;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.primary};
  }

  @media (max-width: ${EXTRA_LARGE_VIEWPORT}px) {
    svg {
      width: 48px;
    }
  }
  @media (max-width: ${MOBILE_VIEWPORT}px) {
    svg {
      width: 38px;
    }
    padding: 0 8px;
    span {
      font-size: 10px;
    }
  }
`;

export const CalendarDay = styled(Header4)`
  text-align: center;
`;

